<template>
  <aside class="agent" v-if="affiliate.data != 0 ">
    <div class="agent-wrap">
      <div class="agent-card">
        <div class="agent-figure">
          <img :src="affiliate.photo_url" />
        </div>
        <div class="agent-meta">
          <p>
            <span>
              ตัวแทนผู้รับผิดชอบ
              <span v-text="affiliate.name" />
            </span>
            <span class="inline">ใบอนุญาตเลขที่ {{ affiliate.card_id }}</span>
            <span class="inline">วันที่หมดอายุ {{ affiliate.card_exp }}</span>
          </p>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  computed: {
    ...mapGetters(['affiliate']),
  },
  methods: {
    ...mapActions({ getSetAffiliate: "getSetAffiliate" })
  },
  async mounted () {
    let uri = window.location.search.substring(1)
    let params = new URLSearchParams(uri)
    let agent_code = params.get("u");
    await this.getSetAffiliate(agent_code);
  }
}
</script>

<style>
</style>